import { REDIRECT_URL_UPDATE_SUCCESS } from '../types/preventLogout';

// Storing token from param
export const getInvestorDistribuorTokenFromURL = (tokenObj: {
  token: string;
  // arn_link: string;
}) => ({
  type: REDIRECT_URL_UPDATE_SUCCESS,
  tokenObj,
});
